'use strict';

const sortSelectOptions = (selectElement) => {
    const currentValue = selectElement.val();
    const optionsList = selectElement.find('option');
    optionsList.sort(function(a, b) {
        const compA = $(a).attr('label').toUpperCase();
        const compB = $(b).attr('label').toUpperCase();
        return (compA < compB) ? -1 : (compA > compB) ? 1 : 0;
    });

    selectElement.html('');
    $(optionsList).each(
        function() {
            const $this = $(this);
            $this.text($this.attr('label'));
            $this.appendTo(selectElement);
        });
    selectElement.val(currentValue);
};

module.exports = sortSelectOptions;
